import { createContext, useCallback, useContext, useRef, useState } from "react";
import apiConfig from "../utils/allApi";
import apiCall from "../utils/apiCall";

const dispatchedDevicesContext = createContext();

const DispatchedDevicesContext = ({ children }) => {
  const [dispatchedDevices, setDispatchedDevices] = useState([]);
  const [dispatchedDevicesLoading, setDispatchedDevicesLoading] = useState(false);
  const hasFetchedRef = useRef(false);
  const fetchInFlightRef = useRef(false);

  const fetchDispatchedDevices = useCallback(async () => {
    if (fetchInFlightRef.current) return;
    fetchInFlightRef.current = true;
    setDispatchedDevicesLoading(true);
    try {
      const res = await apiCall.get(apiConfig.api_pendingDevices);
      if (res?.data?.status === "Success") {
        const message = res.data.message;
        setDispatchedDevices(Array.isArray(message) ? message : []);
      } else {
        setDispatchedDevices([]);
      }
    } catch (error) {
    } finally {
      setDispatchedDevicesLoading(false);
      fetchInFlightRef.current = false;
      hasFetchedRef.current = true;
    }
  }, []);

  const ensureDispatchedDevicesLoaded = useCallback(() => {
    if (!hasFetchedRef.current) {
      fetchDispatchedDevices();
    }
  }, [fetchDispatchedDevices]);

  const refetchDispatchedDevices = useCallback(
    () => fetchDispatchedDevices(),
    [fetchDispatchedDevices],
  );

  return (
    <dispatchedDevicesContext.Provider
      value={{
        dispatchedDevices,
        dispatchedDevicesLoading,
        ensureDispatchedDevicesLoaded,
        refetchDispatchedDevices,
      }}
    >
      {children}
    </dispatchedDevicesContext.Provider>
  );
};

export const useDispatchedDevices = () => useContext(dispatchedDevicesContext);
export default DispatchedDevicesContext;
